import { useState, useRef, useEffect } from 'react'
import { ArrowRight, Lock, AlertCircle } from 'lucide-react'
import { useAssessment } from '../../context/AssessmentContext'
import Shell from '../ui/Shell'
import { getProgress, STEP_LABEL } from '../../lib/flow'

function AgeCollection() {
  const { state, dispatch } = useAssessment()
  const [age, setAge] = useState(state.userAge ? String(state.userAge) : '')
  const [error, setError] = useState('')
  const [shake, setShake] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const submit = (e) => {
    e?.preventDefault()
    const n = parseInt(age, 10)
    if (!age || Number.isNaN(n) || n < 18 || n > 100) {
      setError('Enter an age between 18 and 100.')
      setShake(true)
      window.setTimeout(() => setShake(false), 350)
      inputRef.current?.focus()
      return
    }
    setError('')
    dispatch({ type: 'SET_AGE', payload: n })
    dispatch({ type: 'SET_SCREEN', payload: 'addictionSelection' })
  }

  return (
    <Shell
      label={STEP_LABEL.ageCollection}
      progress={getProgress(state)}
      onBack={() => dispatch({ type: 'SET_SCREEN', payload: 'welcome' })}
    >
      <form className="flow" onSubmit={submit} noValidate>
        <div className="flow__head">
          <h1>How old are you?</h1>
          <p className="flow__lede">Your BetterStep Age is measured against your actual age, so this one matters.</p>
        </div>

        <div>
          <label htmlFor="age" className="visually-hidden">Age in years</label>
          <div className={`input-row${shake ? ' shake' : ''}`}>
            <input
              ref={inputRef}
              id="age"
              type="number"
              inputMode="numeric"
              className="input input--num"
              placeholder="35"
              min={18}
              max={100}
              value={age}
              aria-invalid={error ? 'true' : 'false'}
              aria-describedby={error ? 'age-error' : 'age-note'}
              onChange={(e) => { setAge(e.target.value); if (error) setError('') }}
            />
            <span className="input-row__unit">years</span>
          </div>
          {error && (
            <p id="age-error" className="error" role="alert">
              <AlertCircle size={16} strokeWidth={2} />
              {error}
            </p>
          )}
          <p id="age-note" className="field-note" style={{ marginTop: 12 }}>
            <Lock size={14} strokeWidth={2} />
            Used only for the calculation.
          </p>
        </div>

        <div className="flow__actions">
          <button type="submit" className="btn btn--block">
            Continue
            <ArrowRight size={18} strokeWidth={2.25} />
          </button>
        </div>
      </form>
    </Shell>
  )
}

export default AgeCollection
